<template lang="html">
	<vddl-draggable class="panel__body--item group"
					:draggable="item"
					:index="index"
					:wrapper="list"
					:type="type"
					:moved="handleMovedList"
					v-bind:class="{'search-highlight': isHighlighted}">
		<p class="attribute" v-if="item">
			<span class="fa fa-ellipsis-v drag"></span>
			<template v-if="!itemStructure[item.attribute]">
				{{ item.attribute }}
			</template>
			<template v-else>
				{{( $t(itemStructure[item.attribute].title) || itemStructure[item.attribute].title) }}
			</template>
      <span class="fa fa-trash attribute_editable_trash" title="Delete" @click="deleteElement(item)"></span>
			<br/>
			<span>{{'{' + item.attribute + '}'}}</span>
		</p>
	</vddl-draggable>
</template>

<script>
export default {
	name: 'list-required',
	data () {
		return {
			type: 'list'
		}
	},
	props: [
		'item',
		'list',
		'index',
		'localization',
		'itemStructure',
		'dropzones',
		'toggleInputEdit',
		'onDelete',
		'searchText'
	],
	computed: {
		isHighlighted() {
			if (!this.searchText || this.searchText === '') return false
			const searchLower = this.searchText.toLowerCase()
			const attribute = this.item.attribute ? this.item.attribute.toLowerCase() : ''
			const localization = this.itemStructure[this.item.attribute] ?
				(this.$t(this.itemStructure[this.item.attribute].title) || this.itemStructure[this.item.attribute].title || '').toLowerCase() : ''
			return attribute.indexOf(searchLower) !== -1 || localization.indexOf(searchLower) !== -1
		}
	},
	methods: {
		handleMovedList (item) {

		},
    deleteElement (item) {
      let obj = this.dropzones
      this.recursiveDelete(obj, item)
      if (this.onDelete) {
        this.onDelete()
      }
    },
    recursiveDelete (obj, item) {
      for (let i = 0; i < obj.length; i++) {
        if (typeof obj[i].required === 'object') {
          if (obj[i].attribute === item.attribute) {
            obj.splice(i, 1)
            i--
          } else {
            this.recursiveDelete(obj[i].required, item)
          }
        } else {
          if (obj[i].attribute === item.attribute) {
            obj.splice(i, 1)
            i--
          }
        }
      }
    },
	},
	created () {

	}
}
</script>

<style lang="scss">
.attribute {
	position: relative;
	&:hover &_editable_unlock {
		display: block;
	}

  &:hover &_editable_copy {
    display: block;
  }

  &:hover &_editable_trash {
    display: block;
  }

	&:hover &_editable_unlock_label {
		display: block;
	}

	%editable_shared {
		position: absolute;
    top: 10px;
		padding: 5px;
		border-radius: 50%;
		background-color: #f5f5f5;
		&:hover {
			cursor: pointer;
		}
	}

	%editable_shared_label {
		position: absolute;
		top: 2px;
		right: 25px;
	}

	&_editable_unlock {
		display: none;
    right: 27px;
		@extend %editable_shared
	}

	&_editable_lock {
    right: 27px;
		@extend %editable_shared
	}

	&_editable_unlock_label {
		display: none;
		@extend %editable_shared_label
	}

	&_editable_lock_label {
		@extend %editable_shared_label
	}

  &_editable_copy {
    display: none;
    right: 53px;
    @extend %editable_shared;
  }

  &_editable_trash {
    display: none;
    right: 0;
    color: #ff00008a;
    @extend %editable_shared;
  }
}

.search-highlight {
  background-color: #fff3cd !important;
  border-left: 3px solid #ffc107;
}
</style>
